import { ASSET_PREFIX } from 'utils/constants';
import styles from './RedemptionPrizeOption.module.css';

interface IRedemptionPrizeOption {
  key: number;
  product: {
    id: number;
    description: string | null;
    name: string;
    imageLocation: string | null;
  };
  onClick: () => void;
  selected: boolean;
}

const RedemptionPrizeOption = ({
  key,
  product,
  onClick,
  selected,
}: IRedemptionPrizeOption) => {
  return (
    <div onClick={onClick} key={key} className={styles.card}>
      <img
        src={`${ASSET_PREFIX}/images/radio-button${selected ? '-checked' : ''}.svg`}
        style={{ cursor: 'pointer' }}
        className={styles.checkbox}
      />

      <img
        src={product.imageLocation || undefined}
        className={styles.thumbnail}
      />

      <div className={styles.textContainer}>
        <p className={styles.prizeTitle}>{product.name}</p>
        {product.description && (
          <p className={styles.prizeDescription}>{product.description}</p>
        )}
      </div>
    </div>
  );
};

export default RedemptionPrizeOption;
